import CompanyEmployeeNo from "../steps/company/CompanyEmployeeNo.jsx";
import CompanyForeignTrade from "../steps/company/CompanyForeignTrade.jsx";
import CompanyRevenue from "../steps/company/CompanyRevenue.jsx";
import CompanyTaxForm from "../steps/company/CompanyTaxForm.jsx";
import CompanyVatStatus from "../steps/company/CompanyVatStatus.jsx";
import EvForeignTradeStep from "../steps/ev/EvForeignTrade.jsx";
import EvRevenue from "../steps/ev/EvRevenue.jsx";
import EvTaxForm from "../steps/ev/EvTaxForm.jsx";
import EvVatStatus from "../steps/ev/EvVatStatus.jsx";

const EV_MANUAL_POST_QUICK_RESULT_STEPS = new Set([
  EvTaxForm,
  EvVatStatus,
  EvRevenue,
  EvForeignTradeStep,
]);

const COMPANY_MANUAL_POST_QUICK_RESULT_STEPS = new Set([
  CompanyTaxForm,
  CompanyEmployeeNo,
  CompanyVatStatus,
  CompanyRevenue,
  CompanyForeignTrade,
]);

/** EV manual branch: show live provider count in footer after quick result, before contact. */
export const isEvManualPostQuickResultFooterCountStep = (self, activeStep, steps) => {
  if (self.state?.fillingMethodSelection !== "manual") {
    return false;
  }
  const stepComponent = steps[activeStep]?.component;
  return EV_MANUAL_POST_QUICK_RESULT_STEPS.has(stepComponent);
};

/** Company manual branch: show live provider count in footer after quick result, before contact. */
export const isCompanyManualPostQuickResultFooterCountStep = (self, activeStep, steps) => {
  if (self.state?.fillingMethodSelection !== "manual") {
    return false;
  }
  const stepComponent = steps[activeStep]?.component;
  return COMPANY_MANUAL_POST_QUICK_RESULT_STEPS.has(stepComponent);
};

/** Either EV or company manual post-quick-result step. */
export const isAspManualPostQuickResultFooterCountStep = (self, activeStep, steps) =>
  isEvManualPostQuickResultFooterCountStep(self, activeStep, steps) ||
  isCompanyManualPostQuickResultFooterCountStep(self, activeStep, steps);

/** company_store fields that affect ASP quick-result matching on post-quick-result steps. */
export const getAspManualFooterProviderCountSnapshot = (companyStore = {}) => ({
  companytype: companyStore.companytype ?? "",
  taxform: companyStore.taxform ?? "",
  noofemployees: companyStore.noofemployees ?? "",
  vatFilter: companyStore.vatFilter ?? "",
  vatPayment: companyStore.vatPayment ?? "",
  yearlyrevenue: companyStore.yearlyrevenue ?? 0,
  foreign_trade: companyStore.foreign_trade ?? "",
  foreigntradeEU: companyStore.foreigntradeEU ?? "",
});
